import { render, staticRenderFns } from "./registerUser.vue?vue&type=template&id=13362e28&scoped=true"
import script from "./registerUser.vue?vue&type=script&lang=js"
export * from "./registerUser.vue?vue&type=script&lang=js"
import style0 from "./registerUser.vue?vue&type=style&index=0&id=13362e28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13362e28",
  null
  
)

export default component.exports